import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectUnbindDevices from '../SelectUnbindDevices';
import useApplePaySelectDevices from '@root/hooks/applePay/useApplePaySelectDevices';

const ApplePaySelectDevice = () => {
  const { t } = useTranslation();
  const {
    payDisabled,
    selected,
    priceDetail,
    paying,
    isUnlimited,
    bindApplePayDevices,
    onSelected,
    onClickPay,
  } = useApplePaySelectDevices();

  const selectedLen = bindApplePayDevices.length + selected.length;

  return (
    <SelectUnbindDevices
      isUnlimited
      assignedDevices={bindApplePayDevices}
      selected={selected}
      paying={paying}
      btnDisabled={payDisabled}
      onChange={onSelected}
      onClickPay={onClickPay}
      btnText={t('subscribe_now')}
    >
      <div className="footer-tips">
        {!isUnlimited && bindApplePayDevices.length > 0 && (
          <>
            {selected.length ? (
              <p className="footer-label">{t('currently_subscribed_change')}</p>
            ) : (
              <p className="footer-label">{t('currently_subscribed')}</p>
            )}
          </>
        )}
        <span className="total">
          {t('total')}: ${priceDetail.price}
          {` / ${priceDetail.planUnit === 'year' ? t('year') : t('month')}`}
        </span>
        <span className="float-right">{`${selectedLen} ${
          selectedLen > 1 ? t('devices') : t('device')
        }`}</span>
      </div>
    </SelectUnbindDevices>
  );
};

export default ApplePaySelectDevice;
